import { Mail, Phone, MapPin, MessageCircle } from "lucide-react";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";
import { ContactForm } from "./ContactForm";
import { motion } from "framer-motion";

const Contact = () => {
  return (
    <section id="kontakt" className="py-20 bg-neutral-900 text-white overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <span className="font-semibold text-primary uppercase tracking-wider text-sm">Kostenloses Angebot anfordern</span>
            <h2 className="font-heading text-3xl md:text-5xl mt-2 mb-8">Lass uns deinen Umzug planen</h2>
            
            <div className="space-y-6 mb-12">
              <div className="flex items-center gap-4">
                <div className="bg-primary/20 p-3 rounded-full text-primary">
                  <Mail size={24} />
                </div>
                <div>
                  <p className="text-sm text-neutral-400 font-medium">E-Mail</p>
                  <a href="mailto:savransky.andriy@gmail.com" className="text-lg font-bold hover:text-primary transition-colors">
                    savransky.andriy@gmail.com
                  </a>
                </div>
              </div>
              
              <div className="flex items-center gap-4">
                <div className="bg-primary/20 p-3 rounded-full text-primary">
                  <Phone size={24} />
                </div>
                <div>
                  <p className="text-sm text-neutral-400 font-medium">Telefon</p>
                  <a href="tel:+4915888640762" className="text-lg font-bold hover:text-primary transition-colors">
                    +49 15888 640762
                  </a>
                </div>
              </div>
              <div className="flex items-center gap-4">
                <div className="bg-primary/20 p-3 rounded-full text-primary">
                  <MessageCircle size={24} />
                </div>
                <div>
                  <p className="text-sm text-neutral-400 font-medium">WhatsApp</p>
                  <a href="https://wa.me/491639231591" target="_blank" rel="noopener noreferrer" className="text-lg font-bold hover:text-primary transition-colors">
                    +49 163 9231591
                  </a>
                </div>
              </div>


              <div className="flex items-center gap-4">
                <div className="bg-primary/20 p-3 rounded-full text-primary">
                  <MapPin size={24} />
                </div>
                <div>
                  <p className="text-sm text-neutral-400 font-medium">Standort</p>
                  <p className="text-lg font-bold">Andriy Savransky</p>
                  <p className="text-neutral-300">Erfurter Str. 2 a<br/>86368 Gersthofen</p>
                </div>
              </div>
            </div>
            
            {/* Map Placeholder */}
            <div className="w-full h-64 bg-neutral-800 rounded-lg overflow-hidden border border-neutral-700">
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d677579.5178882426!2d10.1231326!3d48.4412743!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x479ebd68f615fa39%3A0x8505459734392e8f!2sEasy%20Umzug%20Umzugsservice%20Transport%20M%C3%B6belmontage!5e0!3m2!1sde!2sde!4v1765202301565!5m2!1sde!2sde" 
                width="100%" 
                height="100%" 
                style={{ border: 0 }} 
                allowFullScreen={false} 
                loading="lazy" 
                referrerPolicy="no-referrer-when-downgrade"
                title="Google Maps Easy Umzugsservice"
              ></iframe>
            </div>
          </motion.div>
          
          <motion.div 
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="bg-white text-neutral-900 p-8 md:p-10 shadow-xl"
          >
            <h3 className="font-heading text-2xl mb-6">Angebot anfordern</h3>
            <ContactForm />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Contact;